import script from "./JoinClass.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinClass.vue?vue&type=script&setup=true&lang=js"

import "./JoinClass.vue?vue&type=style&index=0&id=1a48cef0&lang=scss&scoped=true"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-szty\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a48cef0"]])

export default __exports__